export interface Feature {
  featureID: string;
  name: string;
  settings?: {
    data: Settings[];
  };
}

export interface Settings {
  key: string;
  value: string;
}

export enum FeaturesEnum {
  TICKET_WALLET = 'Safety Ticket Management',
  BULLETINS = 'Bulletins',
  EQUIPMENT = 'Equipment and Tool Logisitcs',
  LONE_WORKER = 'Lone Worker Monitoring',
  JOURNEY_MANAGEMENT = 'Journey Management',
  FORMS = 'Real-time Documentation',
  CORRECTIVE_ACTIONS = 'Corrective Actions',
  CALENDAR = 'Compliance Calendar',
  STARS = 'STARS',
  NOTIFICATIONS = 'Notifications',
  DOCUMENTS = 'Documents',
  WORKFLOWS = 'Workflows',
  DASHBOARDS = 'Dashboards',
  DYNAMIC_REPORTS = 'Dynamic Reports',
  COMPANY_TOKEN = 'Company Token',
  SSO_MANAGEMENT = 'SSO Management',
  AI_CHAT = 'AI Chat',
}

export enum SettingsEnum {
  ATCO_HYDROGEN_DAILY_TOUR_TRENDS = 'atcoHydrogenDailyTourTrends',
}
